export default __webpack_public_path__ + "static/media/buymecoffee.4899dfb1.png";